import { CaseResource, CaseResourceType, CaseStatus, RoutePlanStatus } from '@/api/apis/case';
import { LogisticsLegResourceType } from '@/api/apis/route';
import { RouteFilterType } from '@/types/route';
import { isAllowedStatus } from '@/utils/helpers';
import { CASE_LOGISTICS_ROUTE_FILTER_TYPE_LIST } from '../RoutePlanner/config';

export const getLegResources = <T,>(
  legResources: LogisticsLegResourceType[],
  resourcesList: CaseResource<T>[],
  resourceType: CaseResourceType,
): CaseResource<T>[] => {
  const resourceIds = new Set(legResources.filter((r) => r.resourceType === resourceType).map((r) => r.resourceId));

  return resourcesList.filter((resource) => resourceIds.has(resource.resourceId));
};

export const getRouteFilterTypeList = (getFilterTitle: (type: RouteFilterType) => string) =>
  CASE_LOGISTICS_ROUTE_FILTER_TYPE_LIST.map((item) => ({
    ...item,
    name: getFilterTitle(item.value as RouteFilterType),
  }));

export const checkStatusAndRouteAllowed = (status: CaseStatus, routePlanningStatus: RoutePlanStatus) => {
  const isCaseLogisticsRouteDetailsAllowed = isAllowedStatus({
    statusFrom: CaseStatus.PendingLogistics,
    statusTo: CaseStatus.Closed,
    currentStatus: status,
  });

  if (!isCaseLogisticsRouteDetailsAllowed && routePlanningStatus !== null) {
    return true;
  }
  return !(isCaseLogisticsRouteDetailsAllowed && routePlanningStatus === null);
};
